import styles from "./EventInfo.module.css";

export interface IEventInfo {
  EventsSection: EventInfoType;
}

export type EventInfoType = {
  name: string;
  time: string;
  address: string;
  imagePath: string;
  imageAlt: string;
  parking: string;
  notes: string;
};

const EventInfo = (props: IEventInfo) => {
  return (
    <>
      <div className={styles.EventInfo}>
        <article className={styles.SiteText}>
          <h2 className={styles.SectionTitle}>
            <u>{props.EventsSection.name.toUpperCase()}</u>
          </h2>
          <ul>
            <li>
              <b>Address:</b> {props.EventsSection.address}
            </li>
            <li>
              <b>Time: </b> {props.EventsSection.time}
            </li>
            <li>
              <b>Parking: </b> {props.EventsSection.parking}
            </li>
          </ul>
          <p>
            <b>{props.EventsSection.notes}</b>
          </p>
        </article>
        <aside>
          <img
            src={props.EventsSection.imagePath}
            alt={props.EventsSection.imageAlt}
          ></img>
        </aside>
      </div>
    </>
  );
};

export default EventInfo;
